import React, { useEffect, useState } from 'react';

import Avatar from '../../submodule/img/01.jpg';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getUserById } from '../../redux/actions/user/getUserById';
import { useForm } from 'react-hook-form';
import Input from '../../components/Input/Input';
import { editComment } from '../../redux/actions/user/editComment';
import Swal from 'sweetalert2';
import { resetEditComment } from '../../redux/slices/user.slice';
import Loading from '../../components/Loading/Loading';
import MessageModal from '../../components/Modal/MessageModal';
import ChatModal from '../Chat/ChatModal';

function ProfileIndex({ userId: userIdProps, isEditComment, vacancyId }) {
  const { userId: userIdParam } = useParams();
  const userId = userIdParam ? userIdParam : userIdProps;
  const dispatch = useDispatch();
  const {
    getUserById: { data: getUserByIdData, error: getUserByIdError, loading: getUserByIdLoading },
    editComment: { data: editCommentData, error: editCommentError, loading: editCommentLoading },
  } = useSelector((state) => state.user);
  useEffect(() => {
    if (editCommentData) {
      Swal.fire({
        title: 'Коментарий сохранен',
        showConfirmButton: false,
        timer: 1000,
        timerProgressBar: true,
      });
      dispatch(resetEditComment());
    }
  }, [editCommentData]);

  useEffect(() => {
    dispatch(getUserById(userId));
  }, [userId]);

  const [divState, setDivState] = useState(false);
  const formComment = useForm({
    defaultValues: {
      comment: getUserByIdData?.candidate?.comment,
    },
  });
  const handleDivState = () => {
    setDivState(!divState);
  };
  const onSubmitComment = (data) => {
    dispatch(
      editComment({
        id: getUserByIdData?.id,
        comment: data?.comment,
      }),
    );
  };

  useEffect(() => {
    if (getUserByIdData) {
      formComment.setValue('comment', getUserByIdData?.candidate?.comment ?? '');
    }
  }, [getUserByIdData]);

  return (
    <div className="mx-auto flex flex-1 flex-col first:flex-row w-full max-w-[1163px]">
      <div className="flex w-full first:w-[20%] mt-0 first:mt-8 mb-2 justify-center">
        <div className="bg-[#E5E5E5] w-[160px] h-[160px] m-5 flex items-center justify-center rounded-lg">
          <svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 24 24">
            <path fill="rgba(0,0,0,0.6)" d="M12 4a4 4 0 0 1 4 4a4 4 0 0 1-4 4a4 4 0 0 1-4-4a4 4 0 0 1 4-4m0 10c4.42 0 8 1.79 8 4v2H4v-2c0-2.21 3.58-4 8-4" />
          </svg>
        </div>
      </div>
      <div className="flex w-full first:w-[60%] mt-0 first:mt-8 mb-2 p-5">
        <div className="flex flex-col justify-start">
          <p className="text-2xl font-medium mb-3">{getUserByIdData?.full_name}</p>
          <p className="text-xl font-medium mb-3">
            {getUserByIdData?.candidate?.sex === null ? 'Пол не указан' : getUserByIdData?.candidate?.sex == true ? 'Муж' : 'Жен'}, {getUserByIdData?.candidate?.age ? `${getUserByIdData?.candidate?.age} лет` : 'Возраст не указан'}
          </p>
          <p className="text-xs font-medium mb-3 text-shaded-text">Адрес</p>
          <p className="text-xl font-medium mb-3">{getUserByIdData?.candidate?.residence?.address ?? '-'}</p>
          <p className="text-xs font-medium mb-3 text-shaded-text">Telegram</p>
          <p className="text-xl font-medium mb-3">{getUserByIdData?.candidate?.telegram_username ?? '-'}</p>
          <p className="text-xs font-medium mb-3 text-shaded-text">Телефон</p>
          <p className="text-xl font-medium mb-5">{getUserByIdData?.phone ?? '-'}</p>
          <p className="text-xl font-medium mb-3">
            Комментарий менеджера{' '}
            {editCommentLoading && (
              <div className="relative inline-block w-[38px] translate-y-[-6px]">
                <Loading />
              </div>
            )}
          </p>
          {isEditComment ? (
            <>
              <Input
                type="textarea"
                className="w-[100%]"
                form={formComment}
                name="comment"
                placeholder={'Текст комментария'}
                rules={{
                  required: false,
                }}
                disabled={false}
              />
              <button type="button" className="text-center text-[14px] border rounded py-2 px-4 mb-2 text-white  mr-2 w-full break-words p-2 xs:w-full hover:bg-[#069488] bg-[#00B2A4] mt-2" onClick={formComment.handleSubmit(onSubmitComment)}>
                Сохранить
              </button>
            </>
          ) : (
            <>{getUserByIdData?.candidate?.comment ? <div className="mb-3">{getUserByIdData?.candidate?.comment}</div> : <p className="flex flex-row text-2xs font-medium mb-3 text-shaded-text">Не заполнен</p>}</>
          )}
        </div>
      </div>
      <div className="flex w-full first:w-[20%] mt-0 first:mt-8 mb-2 p-5 items-start relative">
        <button type="button" class="text-center border rounded py-1 px-2 text-button border-button border-1 hover:text-white bg-white hover:bg-button transition ease-in-out duration-300 absolute right-[100%] top-[20px] h-[37px] -mr-[10px] w-[50px]">
          xls
        </button>
        <div className="mb-4">
          <ChatModal userId={getUserByIdData?.id} userType={getUserByIdData?.type} />
        </div>
      </div>
    </div>
  );
}

export default ProfileIndex;
